import { Modal as ModalModule } from 'common';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import RefundModal from './RefundModal.component';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;

const PartialEligibilityWarningModal = ({
	modalId,
	data: {
		eligiblePrints,
		totalIneligiblePrints,
		totalSelectedPrints,
		onClickLearnMore,
		message = null,
		onContinueClick = null,
		onRefreshGridAPI,
	},
}) => {
	const { showModal, closeAll } = useContext(ModalContext);

	const onPartialContinueClick = () => {
		closeAll(() => {
			showModal({
				component: RefundModal,
				data: {
					eligiblePrints,
					onRefreshGridAPI,
				},
			});
		});
	};

	return (
		<Modal
			modalId={modalId}
			className="history-refund partial-eligibility-warning-modal"
			header="Partial Eligibility Warning"
			primaryButton={{
				onClick: onContinueClick || onPartialContinueClick,
				text: 'Continue',
				type: ModalButtonActionType.Confirm,
			}}
			secondaryButton={{
				text: 'Learn More',
				type: ModalButtonActionType.Ok,
				onClick: onClickLearnMore,
			}}
		>
			<div className="refund-modal-body">
				<p>
					{totalIneligiblePrints} of the {totalSelectedPrints} selected prints
					cannot be refunded.
				</p>
				{message || (
					<>
						<p>To proceed with only the eligible prints, click Continue.</p>
						<p>
							To learn more about refund eligibility rules, click Learn More.
						</p>
					</>
				)}
			</div>
		</Modal>
	);
};

PartialEligibilityWarningModal.propTypes = {
	data: PropTypes.shape({
		// total number of prints out of the selected prints are ineligible for refund
		totalIneligiblePrints: PropTypes.number.isRequired,

		// total number of selected prints
		totalSelectedPrints: PropTypes.number.isRequired,

		eligiblePrints: PropTypes.array,

		onClickLearnMore: PropTypes.func.isRequired,

		onRefreshGridAPI: PropTypes.func,
	}),
};

export default PartialEligibilityWarningModal;
